// extracted by mini-css-extract-plugin
module.exports = {"bottomNav":"BottomNav_bottomNav__ppx4w","links":"BottomNav_links__3OZLr","pad":"BottomNav_pad__36JC9"};